export default __webpack_public_path__ + "static/media/RightHandBatter.35a5316e.png";